module.exports = {
    deliverySaver: {
        landingInclusionsHtml: `
            <li>Unlimited deliveries</li>
            <li>Covers our 'Crate to bench' service and reusable bags</li>
            <li>Applies on all orders over $100</li>
            <li>Cancel renewal at any time</li>
        `,
        freeTrialLandingInclusionsHtml: `
            <li>Unlimited deliveries, including next day delivery (just order before 6pm!)</li>
            <li>Covers our 'Crate to bench' service and reusable bags</li>
            <li>Applies on all orders over $100</li>
            <li>Cancel renewal at any time</li>
        `,
        freeTrialLandingContentHtml: `
            <p>Ready to pick your plan? You won't be charged for 30 days.</p>
            <p class='u-disclaimer'>Free trial for new customers only.</p>
        `,
        landingTitle: 'Welcome back',
        freeTrialLandingTitle: 'Free trial for 30 days',
        freeTrialLandingSubHeader: 'It\'s easy to get started with Delivery Unlimited',
        personalPlansNotEligibleTitle: 'Business Subscription Pricing',
        personalPlansNotEligibleText: 'You are currently logged into a business account, log in with your personal account to subscribe with the below prices.',

        businessPlansNotEligibleTitle: 'Personal Subscription Pricing',
        businessPlansNotEligibleText: 'You are currently logged into a personal account, log in with your business account to subscribe with the below prices.',

        seniorPlansEligibleTitle: 'Great news!',
        seniorPlansEligibleText: "You're eligible for Seniors Delivery Unlimited pricing. Please see your updated prices below.",

        seniorPlansNotEligibleForB2bTitle: "Your're logged into a business account",
        seniorPlansNotEligibleForPersonalTitle: "Your're logged into a personal account",
        seniorPlansNotEligibleText: 'Currently Senior Delivery Unlimited is available for eligible customers only',
    },
    deliverySaverFeatures: {
        freeTrial: '{freeTrialDays} days free trial',
        handPicked: 'All orders hand picked by one of our Personal Shoppers',
        coversPackingCosts: 'Covers crate to bench and reusable bag costs',
        // eslint-disable-next-line no-template-curly-in-string
        minimumOrderAmount: 'Orders must exceed ${minimumOrderAmount}',
        cancelAnytime: 'Cancel your subscription at anytime',
        deliveryAddressPerAccount: '4 delivery addresses per account',
        midweek: 'Covers Delivery costs on Tues - Thurs',
        anyDay: 'Covers Delivery costs 7 days a week',
        deliveryNowSameDay: 'Delivery Now* & Same Day deliveries',
        bulkAndRemoteOrder: 'Special Bulk & Remote orders',
    },
    deliverySaverEligibilities: {
        person60AndOver: 'Persons 60 years and over',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/deliverysaver.js